// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__36DAQ","label":"Category_label__7gD85","content":"Category_content__avCIp","header":"Category_header__37tg5","location":"Category_location__22z4s"};